// extracted by mini-css-extract-plugin
module.exports = {"container":"requirementsText_container__XdqfX","letter":"requirementsText_letter__1-tYe"};